import { StudentExamRouteImport } from './Import'
const { RoutesMap, StudentExamList, StudentExamInstructions, StudentExamStart, StudentExamDetails } = StudentExamRouteImport

const StudentExamRoute = () => [
    { path: RoutesMap.STUDENT_EXAM_LIST.path, element: <StudentExamList /> },
    { path: RoutesMap.STUDENT_EXAM_INSTRUCTIONS.path, element: <StudentExamInstructions /> },
    { path: RoutesMap.STUDENT_EXAM_START.path, element: <StudentExamStart /> },
    { path: RoutesMap.STUDENT_EXAM_DETAILS.path, element: <StudentExamDetails /> },
]
export default StudentExamRoute;
